import React from 'react'

type Props = {
  currentLabel?: string
  onOpen: () => void
}

export default function ChapterPill({ currentLabel, onOpen }: Props) {
  return (
    <button
      onClick={onOpen}
      className="fixed left-4 bottom-6 z-30 px-3 py-2 rounded-full bg-white/10 hover:bg-white/15 border border-white/15 text-sm backdrop-blur"
    >
      <span className="text-white/85">{currentLabel || 'Contents & Settings'}</span>
    </button>
  )
}

